import { renderKoDataTable, renderKoEmptyState } from '~/components/templates/listPageDataTable';
import { renderRecruitingStatusCell, renderRecruitingTextCell } from '~/components/templates/recruiting/RecruitingTable';
import { html, LpButton, LpTable } from '~/design-system';
export function renderQuestionBanksTable({ getSortAttributes, }) {
    const columns = getQuestionBankTableColumns(getSortAttributes);
    return renderKoDataTable({
        title: 'Question Banks',
        titleIcon: 'cards',
        caption: 'Question bank definitions',
        columns,
        className: 'question-banks-table',
        children: renderQuestionBanksTableBody(columns),
    });
}
function getQuestionBankTableColumns(getSortAttributes) {
    return [
        {
            key: 'id',
            label: 'ID',
            sortable: true,
            resizable: true,
            width: 88,
            minWidth: 72,
            sortAttributes: getSortAttributes('id'),
        },
        {
            key: 'identifier',
            label: 'Identifier',
            sortable: true,
            resizable: true,
            minWidth: 240,
            sortAttributes: getSortAttributes('identifier'),
        },
        {
            key: 'active',
            label: 'Status',
            sortable: true,
            resizable: true,
            width: 128,
            minWidth: 104,
            sortAttributes: getSortAttributes('active'),
        },
        {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            width: 96,
            minWidth: 88,
            required: true,
        },
    ];
}
function renderQuestionBanksTableBody(columns) {
    return html `
        ${LpTable.Body({
        attributes: {
            'data-bind': 'foreach: questionBanks',
        },
        children: LpTable.Row({
            children: html `
                    ${renderRecruitingTextCell({ column: columns[0], binding: 'id', className: 'question-banks-table__id' })}
                    ${renderRecruitingTextCell({ column: columns[1], binding: 'identifier', className: 'question-banks-table__identifier' })}
                    ${renderRecruitingStatusCell({
                column: columns[2],
                className: 'question-banks-table__status',
                badgeClassName: 'question-bank-status',
                textBinding: "active ? 'Active' : 'Inactive'",
                cssBinding: `
                            'task-status--success': active,
                            'task-status--pending': !active
                        `,
            })}
                    ${LpTable.Cell({
                column: columns[3],
                className: 'question-banks-table__actions',
                children: html `
                            <div class="question-banks-table__actions-inner">
                                ${LpButton({
                    ariaLabel: 'Edit',
                    prefixIcon: 'pencil-simple',
                    size: 'sm',
                    shape: 'square',
                    variant: 'ghost',
                    className: 'list-edit-action',
                    attributes: {
                        'data-bind': 'click: $parent.onClickEdit',
                    },
                })}
                            </div>
                        `,
            })}
                `,
        }),
    })}
        ${renderKoEmptyState({
        colSpan: columns.length,
        visibleBinding: 'questionBanks().length === 0',
        title: 'No question banks found',
        description: 'Create a question bank to organize recruiting questions.',
        icon: 'folder-simple',
    })}
    `;
}
